<template lang="pug">
  .alljapanbutton(v-bind:class="{'alljapanbutton-active': is_active}")
    button.alljapanbutton_button(v-bind:class="{'alljapanbutton_button-active': is_active}" v-on:click="toggleAlljapan")
      svg.alljapanbutton_icon(width="21" height="14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 14")
        path.alljapanbutton_flag(d="M0 0h21v14H0z" v-bind:class="{'alljapanbutton_flag-active': is_active}")
        circle.alljapanbutton_sun(cx="10.5" cy="7" r="3.85" v-bind:class="{'alljapanbutton_sun-active': is_active}")
      |{{label}}
</template>
<script>
  import {mapState, mapActions} from 'vuex';

  export default{
    props: ['is_active'],
    data: function(){
      return {
        label_ja: "日本",
        label_en: "Japan"
      }
    },
    computed: {
      ...mapState([
        'lang'
      ]),
      label(){
        return /ja/.test(this.lang) ? this.label_ja : this.label_en;
      }
    },
    methods: {
      ...mapActions([
        'toggleAlljapan'
      ]),
    }
  }
</script>
<style lang="sass">
  .alljapanbutton
    width: 100%
    &_button
      width: 100%
      height: 30px
      border-radius: 5px
      border: none
      background-color: #fff
      color: #666666
      transition: background-color .1s linear, color .1s linear
      display: flex
      justify-content: center
      align-items: center
      cursor: pointer
      outline: none
      &-active
        background-color: #000
        color: #fff
    &_icon
      margin-right: 5px
    &_flag
      fill: #ccc
      transition: fill .1s linear
      &-active
        fill: #fff
    &_sun
      fill: #333
      transition: fill .1s linear
      &-active
        fill: #FF465A

    &:hover
      .alljapanbutton
        &_button
          background-color: #F0DC00
          color: #000
        &_flag
          fill: #fff
        &_sun
          fill: #000000

</style>